import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-action-center',
  templateUrl: './action-center.component.html',
  styleUrls: ['./action-center.component.scss']
})
export class ActionCenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
